module.exports = __webpack_public_path__ + "img/logo-brand-force.1bb5f687.svg";